module.exports = __webpack_public_path__ + "static/sport/slide7.46f8c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/slide7.png
// module id = UL19
// module chunks = 0